import { gql } from '@apollo/client';
import { gradesFragment, rateUnitFragment } from 'helper/fragment';

export const OFFERS_QUERY = gql`
  ${rateUnitFragment}
  query offers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    offers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      offers {
        updatedByUserId
        createdByUserId
        createdAt
        id
        activeBids
        inactiveBids
        offerType
        totalQty
        minimumQty
        rate
        quantityUnit
        actualQuantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        status
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          traderType
          callingCode {
            id
            callingCode
          }
          dedicatedRM {
            id
            firstName
            lastName
            phone
            callingCode {
              id
              callingCode
            }
          }
          dedicatedPurchaseManager {
            id
            firstName
            lastName
            phone
            callingCode {
              id
              callingCode
            }
          }
        }
        portOfLoading {
          id
          name
          city
        }
        portsOfDischarge {
          id
          name
          city
        }
        offerCreatedFor
        nonRegisteredUserName
        nonRegisteredUserPhoneNumber
        nonRegisteredUserCallingCode
        createdByUser {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const DEMANDS_QUERY = gql`
  ${rateUnitFragment}
  query demands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    demands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      demands {
        id
        createdAt
        activeBids
        inactiveBids
        demandType
        totalQty
        minimumQty
        rate
        actualQuantityUnit
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        status
        createdByUserId
        updatedByUserId
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          traderType
          callingCode {
            id
            callingCode
          }
          dedicatedRM {
            id
            firstName
            lastName
            phone
            callingCode {
              id
              callingCode
            }
          }
          dedicatedPurchaseManager {
            id
            firstName
            lastName
            phone
            callingCode {
              id
              callingCode
            }
          }
        }
        portsOfDischarge {
          id
          name
          city
        }
        demandCreatedFor
        nonRegisteredUserName
        nonRegisteredUserPhoneNumber
        nonRegisteredUserCallingCode
        createdByUser {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          traderType
          callingCode {
            id
            callingCode
          }
        }
        demandGroupId
        isGroupedDemand
        groupedGradeNames
        linkedDemands {
          id
          totalQty
          rate
          grades {
            id
            name
            productSubCategoryManufacturer
          }
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const FOREIGN_OFFER_BY_ID = gql`
  ${gradesFragment}
  ${rateUnitFragment}
  query allForeignOffers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForeignOffers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      foreignOffers {
        id
        rate
        offerType
        validityInHours
        status
        quantityUnit
        grade {
          ...gradesInfo
        }
        totalQty
        minimumQty
        city {
          id
          cityName
        }
        state {
          id
          stateName
        }
        trader {
          id
          firstName
          email
        }
        rateUnit {
          ...rateUnitInfo
        }
        minDeliveryDelay
        maxDeliveryDelay
        validityStartTime
        validityExpireTime

        portOfDischarge {
          name
          id
        }
        portOfLoading {
          id
          name
        }
        expectedShipmentDate
        packagingTypeId {
          id
          type
        }
        deliveryTerm {
          id
          term
        }
        paymentTerm {
          id
          term
        }
        createdAt
        acceptedBids
        rejectedBids
        totalOrders
        deliveredOrders
      }
    }
  }
`;

export const FORWARD_OFFER_BY_ID = gql`
  ${gradesFragment}
  ${rateUnitFragment}
  query allForwardOffers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForwardOffers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      forwardOffers {
        id
        offerType
        validityInHours
        rate
        quantityUnit
        status
        grade {
          ...gradesInfo
        }
        totalQty
        minimumQty
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        trader {
          id
          firstName
          email
        }
        rateUnit {
          ...rateUnitInfo
        }
        minDeliveryDelay
        maxDeliveryDelay
        validityStartTime
        validityExpireTime
        packagingTypeId {
          id
          type
        }
        paymentTerm {
          id
          term
        }

        acceptedBids
        rejectedBids
        totalOrders
        deliveredOrders
      }
    }
  }
`;

export const FORWARD_DEMAND_BY_ID = gql`
  ${gradesFragment}
  ${rateUnitFragment}
  query allForwardDemands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForwardDemands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      forwardDemands {
        id
        demandType
        validityInHours
        rate
        quantityUnit
        status
        paymentTerm {
          id
          term
        }
        grades {
          ...gradesInfo
        }
        rateUnit {
          ...rateUnitInfo
        }
        totalQty
        minimumQty
        city {
          id
          cityName
        }
        state {
          stateName
          country {
            id
            country
          }
          id
        }
        trader {
          id
          firstName
          email
        }

        minDeliveryDelay
        maxDeliveryDelay
        validityStartTime
        validityExpireTime
        minimumLiftingQty
        packagingType {
          id
          type
        }

        acceptedBids
        rejectedBids
        totalOrders
        deliveredOrders
      }
    }
  }
`;

export const LIVE_OFFER_BY_ID = gql`
  ${rateUnitFragment}
  query liveOffers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    liveOffers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      offers {
        offer {
          id
          rate
          offerType
          validityInHours
          status
          grade {
            id
            name
            category {
              id
              name
            }
          }
          totalQty
          minimumQty
          quantityUnit
          validityStartTime
          validityExpireTime
          city {
            id
            cityName
          }
          state {
            id
            stateName
            country {
              id
              country
            }
          }
          trader {
            id
            firstName
            email
          }
          rateUnit {
            ...rateUnitInfo
          }
          packagingTypeId {
            id
            type
          }
          createdAt
          acceptedBids
          rejectedBids
          totalOrders
          deliveredOrders
        }
      }
    }
  }
`;

export const LIVE_DEMAND_BY_ID = gql`
  ${rateUnitFragment}
  query liveDemands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    liveDemands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      demands {
        demand {
          id
          rate
          demandType
          validityInHours
          status
          rateUnit {
            ...rateUnitInfo
          }
          grades {
            id
            name
            category {
              id
              name
            }
          }
          totalQty
          minimumQty
          minimumLiftingQty

          city {
            id
            cityName
          }
          state {
            id
            stateName
            country {
              id
              country
            }
          }

          validityStartTime
          validityExpireTime

          trader {
            id
            firstName
            email
          }
          packagingType {
            id
            type
          }
          quantityUnit

          acceptedBids
          rejectedBids
          totalOrders
          deliveredOrders
        }
      }
    }
  }
`;

export const FOREIGN_DEMAND_BY_ID = gql`
  ${rateUnitFragment}
  query allForeignDemands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForeignDemands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      foreignDemands {
        id
        rate
        quantityUnit
        demandType
        validityInHours
        status
        grades {
          name
          id
          category {
            id
            name
          }
        }
        rateUnit {
          ...rateUnitInfo
        }
        totalQty
        minimumQty
        minimumLiftingQty
        city {
          id
          cityName
        }
        state {
          id
          stateName
        }
        trader {
          id
          firstName
          email
        }
        minDeliveryDelay
        maxDeliveryDelay
        validityStartTime
        validityExpireTime

        packagingType {
          id
          type
        }
        portOfDischarge {
          id
          name
        }
        paymentTerm {
          id
          term
        }
        deliveryTerm {
          id
          term
        }
        acceptedBids
        rejectedBids
        totalOrders
        deliveredOrders
      }
    }
  }
`;

// export const FOREIGN_DEMAND_BY_ID = gql`
//   query allForeignDemands(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allForeignDemands(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       foreignDemands {
//         id
//         rate
//         demandType
//         validityInHours
//         status
//         grades {
//           name
//           id
//         }
//         totalQty
//         minimumQty
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         trader {
//           id
//           firstName
//           email
//         }
//         minDeliveryDelay
//         maxDeliveryDelay
//         portOfLoading {
//           name
//         }
//         portOfDischarge {
//           name
//         }
//         expectedShipmentDate
//         packagingTypeId {
//           id
//           type
//         }
//         deliveryTerm {
//           term
//         }
//       }
//     }
//   }
// `;

// export const FOREIGN_DEMAND_BY_ID = gql`
//   query allForeignDemands(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allForeignDemands(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       foreignDemands {
//         id
//         rate
//         demandType
//         validityInHours
//         status
//         grades {
//           name
//           id
//         }
//         totalQty
//         minimumQty
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         trader {
//           id
//           firstName
//           email
//         }
//         minDeliveryDelay
//         maxDeliveryDelay
//         portOfLoading {
//           name
//         }
//         portOfDischarge {
//           name
//         }
//         expectedShipmentDate
//         packagingTypeId {
//           id
//           type
//         }
//         deliveryTerm {
//           term
//         }
//       }
//     }
//   }
// `;

export const STATES_BY_COUNTRY = gql`
  query statesByCountry($country: ID!) {
    statesByCountry(country: $country) {
      country {
        country
      }
      stateName
      id
    }
  }
`;
export const COUNTRY_LISTS = gql`
  query countryCurrencies {
    countryCurrencies {
      id
      country
      callingCode
    }
  }
`;

export const PORTS = gql`
  query ports {
    ports {
      id
      name
    }
  }
`;

export const PACKAGING_TYPES = gql`
  query packagingTypes {
    packagingTypes {
      id
      type
    }
  }
`;

export const CITY_BY_COUNTRY_AND_STATE = gql`
  query citiesByStateAndCountry($state: ID!, $country: ID!) {
    citiesByStateAndCountry(state: $state, country: $country) {
      cityName
      id
    }
  }
`;
export const CITY_BY_STATE = gql`
  query citiesByState($state: ID!) {
    citiesByState(state: $state) {
      cityName
      id
    }
  }
`;

export const CREATE_CITY = gql`
  mutation createCity($city: CityInput) {
    createCity(city: $city)
  }
`;

export const UPDATE_CITY = gql`
  mutation updateCity($city: CityInput) {
    updateCity(city: $city)
  }
`;

export const DELETE_CITY = gql`
  mutation deleteCity($id: ID) {
    deleteCity(id: $id)
  }
`;

export const DELETE_OFFER = gql`
  mutation deleteOffer($id: ID!) {
    deleteOffer(id: $id)
  }
`;

export const DELETE_DEMAND = gql`
  mutation deleteDemand($id: ID!) {
    deleteDemand(id: $id)
  }
`;

export const ADMIN_UPDATE_OFFER = gql`
  mutation adminUpdateOffer(
    $id: ID!
    $totalQty: Int!
    $minimumQty: Int!
    $rate: Float!
    $validityInHours: Int!
    $validityStartTime: String!
    $validityExpireTime: String!
    $cityId: ID
  ) {
    adminUpdateOffer(
      id: $id
      totalQty: $totalQty
      minimumQty: $minimumQty
      rate: $rate
      validityInHours: $validityInHours
      validityStartTime: $validityStartTime
      validityExpireTime: $validityExpireTime
      cityId: $cityId
    )
  }
`;

export const ADMIN_UPDATE_OFFER_STATUS = gql`
  mutation adminUpdateOfferStatus($id: ID!, $status: ActiveStatus!) {
    adminUpdateOfferStatus(id: $id, status: $status)
  }
`;

export const ADMIN_UPDATE_DEMAND = gql`
  mutation adminUpdateDemand(
    $id: ID!
    $totalQty: Int!
    $rate: Float!
    $validityInHours: Int!
    $validityStartTime: String!
    $validityExpireTime: String!
    $cityId: ID
  ) {
    adminUpdateDemand(
      id: $id
      totalQty: $totalQty
      rate: $rate
      validityInHours: $validityInHours
      validityStartTime: $validityStartTime
      validityExpireTime: $validityExpireTime
      cityId: $cityId
    )
  }
`;

export const ADMIN_UPDATE_DEMAND_STATUS = gql`
  mutation adminUpdateDemandStatus($id: ID!, $status: ActiveStatus!) {
    adminUpdateDemandStatus(id: $id, status: $status)
  }
`;

export const UPDATE_OFFER = gql`
  mutation updateOffer($offer: OfferInput) {
    updateOffer(offer: $offer)
  }
`;

export const UPDATE_DEMAND = gql`
  mutation updateDemand($input: DemandInput) {
    updateDemand(input: $input)
  }
`;

export const UPDATE_FORWARD_OFFER = gql`
  mutation updateForwardOffer($forwardOffer: ForwardOfferInput) {
    updateForwardOffer(forwardOffer: $forwardOffer)
  }
`;

export const UPDATE_FORWARD_DEMAND = gql`
  mutation updateForwardDemand($forwardDemand: ForwardDemandInput) {
    updateForwardDemand(forwardDemand: $forwardDemand)
  }
`;

export const UPDATE_FOREIGN_OFFER = gql`
  mutation updateForeignOffer($foreignOffer: ForeignOfferInput) {
    updateForeignOffer(foreignOffer: $foreignOffer)
  }
`;

export const UPDATE_FOREIGN_DEMAND = gql`
  mutation updateForeignDemand($foreignDemand: ForeignDemandInput) {
    updateForeignDemand(foreignDemand: $foreignDemand)
  }
`;
export const UPDATE_OFFER_STATUS = gql`
  mutation updateOfferStatus($id: ID, $status: ActiveStatus) {
    updateOfferStatus(id: $id, status: $status)
  }
`;
export const UPDATE_DEMAND_STATUS = gql`
  mutation updateDemandStatus($id: ID, $status: ActiveStatus) {
    updateDemandStatus(id: $id, status: $status)
  }
`;

export const GRADE_FAVOURITED_BY_USERS = gql`
  query gradeFavouritedByUsers($gradeId: ID!, $pageNo: Int, $pageSize: Int) {
    gradeFavouritedByUsers(
      gradeId: $gradeId
      pageNo: $pageNo
      pageSize: $pageSize
    ) {
      users {
        username
        traderId
        entityName
        phoneNumber
      }
      totalCount
      totalPages
    }
  }
`;
// export const UPDATE_ORDER = gql`
//   mutation updateOrder($order: OrderInput!) {
//     updateOrder(order: $order) {
//       updateOrder {
//         id
//       }
//     }
//   }
// `;

// export const UPDATE_ORDER = gql`
//   mutation updateOrder($order: OrderInput!) {
//     updateOrder(order: $order) {
//       updateOrder {
//         id
//       }
//     }
//   }
// `;
